import { GroupedSideBar } from "./GroupedSideBar";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const MainDrawerItems = () => {
  const Settings = useSettingsContext();

  return <>
    {Settings.sidebar?.groups && <GroupedSideBar />}
  </>
}